<template>
  <SrpDetailsSummary class="how-it-works-wrap" :isOpened="props.isOpened">
    <template #heading>
      <h2 class="global-h2">
        <span><span>How Custom Collabs Work</span></span>
      </h2>
    </template>
    <template #details>
      <div style="margin-bottom: 8px; border-bottom: 1px rgba(0, 0, 0, 0.15) solid"></div>

      <!-- "How it works" -->
      <div class="how-it-works">
        <ol class="how-it-works__ol-list">
          <li>The destination chose you to work with, congrats!</li>
          <li>Message the destination to hash out deliverables, compensation, and timing.</li>
          <li>Accept the work agreement to formalize the collaboration.</li>
          <li>Do the work and send the deliverables.</li>
          <li>The destination will review the work and transfer compensation!</li>
        </ol>

        <NoteWithIcon>
          <template #icon><IconEmbedded name="info-simple_4" :size="28" /></template>
          <template #text>
            <div>
              <h5 class="global-h5" style="margin-bottom: 5px">Important</h5>
              <span>
                You are working DIRECTLY with the destination.<br />
                - Shrpa does not facilitate payments, comps or communication.<br /><br />
                <b>If you have questions, message the destination as much as needed.</b><br />
                - Frequent and clear communication is key to a successful collab!
              </span>
            </div>
          </template>
        </NoteWithIcon>

        <p class="global-p" style="margin-top: 20px">Questions? Reach out to <CopyTextNew>support@shrpa.com</CopyTextNew></p>
      </div>
      <!-- / "How it works" -->
    </template>
  </SrpDetailsSummary>
</template>

<script setup lang="ts">
// Components
import SrpDetailsSummary from "@components/ui/SrpDetailsSummary.vue";
import SrpButton from "@components/ui/SrpButton.vue";
import NoteWithIcon from "@components/NoteWithIcon.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";
import CopyTextNew from "@components/CopyTextNew.vue";

const props = withDefaults(
  defineProps<{
    isOpened?: boolean;
  }>(),
  {
    isOpened: true,
  }
);
</script>

<style scoped lang="scss">
@import "@/scss/screen-size-ranges.scss";
@import "@/scss/variables.scss";

// "How it works" ==============================================================
.how-it-works {
  &__ol-list {
    @include standardFont;
    padding-left: 15px;
    margin-left: 0;

    li {
      margin-bottom: 7px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

// "How it works" wrap =========================================================
.how-it-works-wrap {
  padding: 20px 25px 24px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 3px 15px -5px rgba(0, 0, 0, 0.4);
}
</style>
